import React from 'react';
import { TipsMapType } from '../index';

export const videoHeadText: TipsMapType = {
  en: (
    <>
      There is a delay in data updating, so the data on this page (such as
      views, interactions, likes, shares, comments, followers, etc.) are not
      realtime data.
      <br />
      <br />
      Update frequency: <br />
      Posts from Monitor accounts will be updated once a day for up to 7 days.
      <br />
      <br />
      Among posts from keyword sources, only posts on Youtube, Twitch and Tiktok
      channels are updated once a day, up to 7 days; Posts from other sources
      have no updates.
    </>
  ),
  zh: (
    <>
      数据更新存在延时，所以本页数据（例如观看、互动量、点赞、分享、评论、关注等）非实时数据。{' '}
      <br />
      <br />
      更新频率： <br />
      官号来源的帖子每天将更新1次，最多更新7天。
      <br />
      <br />
      关键词来源的帖子中，仅 Youtube、Twitch、Tiktok
      渠道的帖子每天更新1次，最多更新7天；其他来源帖子无数据更新。
    </>
  ),
};

export const engagementText: TipsMapType = {
  en: 'Video Engagement: Summary of Likes, Dislikes, Comments and Shares of all Videos.',
  zh: '视频互动量：视频的点赞量、点踩量、评论量、转发量的汇总。',
};

export const hoursWatchedText: TipsMapType = {
  en: 'The hour watched duration: the total duration from the time when users enter the live room to the time they leave.',
  zh: '直播观看时长：从用户进入直播间开始到离开直播间的总时长。',
};

export const peakCCVText: TipsMapType = {
  en: 'Peak CCV (Peak concurrent viewers): take the peak value of viewers watching the stream live.',
  zh: '直播观众峰值：观看直播的观众的峰值。',
};

export const avgCCVText: TipsMapType = {
  en: 'Avg CCV (Average concurrent viewers): take the average value of viewers watching the stream live.',
  zh: '直播观众平均值：观看直播的观众的平均值。',
};

export const airtimeText: TipsMapType = {
  en: 'Airtime: take the sum value of the hours broadcast by all streamers.',
  zh: '直播时长：该时段所有直播间的在线时长总和。',
};

// export const influencerSumTipsText: TipsMapType = {
//   en: (
//     <>
//       The types of influencer included in the aggregated statistics are Video
//       Influencers and Post Influencers. As the data for Video Influencers and
//       Post Influencers are obtained through analysis of opinion videos and
//       posts, and the data for live streamers are collected from the
//       <img
//         style={{ verticalAlign: 'middle', margin: '0 5px' }}
//         src={hatchetIcon}
//       ></img>
//       Stream Hatchet platform, it is not possible to include live streamers in
//       the aggregated statistics here.
//     </>
//   ),
//   zh: (
//     <>
//       汇总统计的网红类型包括视频网红和文字帖网红。由于视频网红和文字贴网红数据是通过舆情发帖数据统计获得，而直播网红数据取自
//       <img
//         style={{ verticalAlign: 'middle', margin: '0 5px' }}
//         src={hatchetIcon}
//       ></img>
//       Stream Hatchet平台，所以此处汇总数据无法统计到直播网红。
//     </>
//   ),
// };

export const communityViewPerPostTipsText: TipsMapType = {
  en: 'The statistics represent the average views per post for game-related content (videos and posts) published by this influencer.',
  zh: '统计数据为该influencer发布的此游戏相关内容（视频和帖子）的条均播放量。',
};

export const communityFollowersTipsText: TipsMapType = {
  en: 'Followers source of each platform: Reddit is taken from Members, Youtube is taken from Subscribe, and other platforms are taken from Followers.',
  zh: '各平台的 Followers 取值：Reddit 取自 Members，Youtube 取自 Subscribe，其他平台取自Followers。',
};

export const communityGrowthOfFollowersTipsText: TipsMapType = {
  en: 'Followers difference of adjacent intervals: The difference is obtained by subtracting the data of the previous interval from the current interval. Negative numbers representing declines and positive numbers representing increases.',
  zh: '粉丝增长量：通过本期区间减去上期区间的数据获得差值，负数代表粉丝量下降，正数代表粉丝量上涨。',
};

export const communityTablePostEngagementTipsText: TipsMapType = {
  en: 'Post Engagements: the number of Engagements of text posts posted by the Influencers, including likes, dislikes, comments, and shares.',
  zh: '图文贴互动量：该网红发布的所有图文贴的互动量，包括点赞、点踩、评论、转发。',
};

export const communityTableVideoEngagementTipsText: TipsMapType = {
  en: 'Video Engagements: the number of Engagements of videos posted by the Influencers, including likes, dislikes, comments, and shares.',
  zh: '视频互动量：该网红发布的所有视频贴的互动量，包括点赞、点踩、评论、转发。',
};

export const communityTableAllEngagementTipsText: TipsMapType = {
  en: 'All Engagements: the number of Engagements of videos and posts posted by the Influencers, including likes, dislikes, comments, and shares.',
  zh: '总互动量：该网红发布的所有视频贴和图文贴的互动量，包括点赞、点踩、评论、转发。',
};

export const communityVideoEngagementTipsText: TipsMapType = {
  en: 'Video Engagements: the number of Engagements of videos posted by the Influencers, including likes, dislikes, comments, and shares.',
  zh: '视频互动量：该网红发布的所有视频贴的互动量，包括点赞、点踩、评论、转发。',
};

export const communityPostEngagementTipsText: TipsMapType = {
  en: 'Post Engagements: the number of Engagements of text posts posted by the Influencers, including likes, dislikes, comments, and shares.',
  zh: '图文贴互动量：该网红发布的所有图文贴的互动量，包括点赞、评论、转发。',
};

export const communityVideoKeywordsTipsText: TipsMapType = {
  en: 'Through the clustering of text information from Videos, the top 5 keywords of Mentions were obtained.',
  zh: '通过视频 Videos 的文本信息进行聚类，获得声量排名前5的关键词。',
};

export const communityPostKeywordsTipsText: TipsMapType = {
  en: 'Through the clustering of text information from Posts, the top 5 keywords of Mentions were obtained.',
  zh: '通过文字贴 Posts 的文本信息进行聚类，获得声量排名前5的关键词。',
};

export const communityPeakCCVTipsText: TipsMapType = {
  en: 'Peak CCV (Peak concurrent viewers): take the peak value of viewers watching the stream live.',
  zh: '直播观众峰值：观看直播的观众的峰值。',
};

export const communityVideoInfluencerTipsText: TipsMapType = {
  en: 'Video influencers: Obtain top ranking influencers by summarizing videos from Opinion Database. Data sources include influencers with more than 5000 followers and those who have posted in the selected time range on each platform.',
  zh: '视频网红：通过汇总舆情视频，获得排名前列的网红。网红数据来源包括各平台粉丝量在5000以上的网红以及所选时间范围有发过贴的网红。',
};

export const communityVideoPublicationsTipsText: TipsMapType = {
  en: 'Statistics are only collected on the videos published by Influencer on this game, excluding content not related to the game.',
  zh: '仅根据 Influencer 针对本游戏的视频内容进行统计，不包括非本游戏相关内容。',
};

export const communityPostPublicationsTipsText: TipsMapType = {
  en: 'Statistics are only collected on the posts published by Influencer on this game, excluding content not related to the game.',
  zh: '仅根据 Influencer 针对本游戏的文字贴内容进行统计，不包括非本游戏相关内容。',
};

export const communityPostInfluencerTipsText: TipsMapType = {
  en: 'Post influencers: Obtain top ranking influencers by summarizing posts from Opinion Database. Data sources include influencers with more than 5000 followers and those who have posted in the selected time range on each platform.',
  zh: '文字帖网红：通过汇总舆情文字贴，获得排名前列的网红。网红数据来源包括各平台粉丝量在5000以上的网红以及所选时间范围有发过贴的网红。',
};

export const communityInfluencerAirtimeTipsText: TipsMapType = {
  en: 'Airtime: take the sum value of the hours broadcast by all streamers.',
  zh: '直播时长：所有主播的直播间在线时长的汇总值。',
};

export const communityInfluencerAvgCCVTipsText: TipsMapType = {
  en: 'Avg CCV (Average concurrent viewers): The daily average viewers of the live stream is calculated according to the selected time range, and the average value of these days is taken as Avg CCV.',
  zh: '直播观众平均值：根据所选的时间范围，计算本游戏每日直播观众的平均值，取这段时间的日平均值作为直播观众平均值。',
};

export const communityInfluencerFollowersTop10TipsText: TipsMapType = {
  en: 'Take the top 10 influencers with the number of followers on the whole channel. Followers source of each platform: Reddit is taken from Members, Youtube is taken from Subscribe, and other platforms are taken from Followers.',
  zh: '取全平台的粉丝量排名前 10 的网红，将他们的粉丝量求平均值。各平台的 Followers 取值：Reddit 取自 Members，Youtube 取自 Subscribe，其他平台取自 Followers。',
};

export const communityInfluencerTipsText: TipsMapType = {
  en: 'Influencers type include video influencers and post influencers. Data sources include influencers with more than 5000 followers and those who have posted in the selected time range on each platform.',
  zh: '网红类型包括视频网红 和文字帖网红。网红数据来源包括各平台粉丝量在5000以上的网红以及所选时间范围有发过贴的网红。',
};

export const communityInfluencerTitleText: TipsMapType = {
  en: (
    <>
      Update Frequency: Influencers data on this page is updated daily,
      excluding those Influencers that do not have followers data.
      <br />
      Followers Update: Only update the followers of opinion leaders with more
      than 5K followers or who post on that day.
      <br />
      Calculation logic of daily views, likes and comments: Summarize posts on a
      daily basis, and count the data of these posts (such as views, likes and
      comments and engagement) as the views, likes, comments and engagement on
      the Posting day.
    </>
  ),
  zh: (
    <>
      更新频率：本页面的KOL数据（除缺少粉丝量数据的KOL外）每日更新一次。
      <br />
      粉丝量更新：每日仅更新粉丝量大于5K或者当天有发帖的网红的粉丝量。
      <br />
      每日观看、点赞、评论计算逻辑：按日汇总当天发的帖子数，统计这些帖子的数据（如观看、点赞、评论、互动）作为发帖日的观看、点赞、评论、互动。
    </>
  ),
};

export const communityInfluencerGenreCreatorListTitleText: TipsMapType = {
  en: (
    <>
      Update Frequency: Influencers data on this page is updated daily,
      excluding those Influencers that do not have followers data.
    </>
  ),
  zh: <>更新频率：本页面的KOL数据（除缺少粉丝量数据的KOL外）每日更新一次。</>,
};

export const communityStreamingAvgText: TipsMapType = {
  en: 'Avg CCV (Average concurrent viewers): Average number of viewers per platform. The calculation method is as follows: After obtaining the average value of viewers on each platform, the data is summarized, and then the average viewers value is calculated based on the summarized results.',
  zh: '直播观众平均值：各平台平均拥有的直播观众数。计算方法如下：获得各平台的直播观众平均值后，进行数据汇总，再针对汇总结果求平均。',
};

export const communityStreamingPeakCCVMaxText: TipsMapType = {
  en: 'Peak CCV (Peak concurrent viewers): The daily peak viewers of the live stream is calculated according to the selected time range, and the maximum value of these days is taken as Peak CCV.',
  zh: '直播观众峰值：根据所选的时间范围，计算本游戏每日直播观众的峰值，取其中的最大值作为直播观众峰值。',
};

export const communityHashtagTitleText: TipsMapType = {
  en: <>Hashtag data was updated from March 22, 2023.</>,
  zh: <>Hashtag数据从2023-03-22开始更新。</>,
};

export const communitySteamingCommonTitleText: TipsMapType = {
  en: 'Since the data is sourced from Stream Hatchet, only UTC+0 data is provided.',
  zh: '由于数据来源于Stream Hatchet，仅提供UTC+0数据',
};


export const communityVideoChannelText: TipsMapType = {
  en: 'AI-powered tag filtering is only available for videos from YouTube and TikTok. Data from other channels is raw and unprocessed.',
  zh: '当前仅 YouTube 和 TikTok 渠道的视频数据支持 AI 标签过滤处理，其他渠道数据为原始抓取结果。',
};

export const communityVideoEngagementRateText: TipsMapType = {
  en: 'Video Engagement Rate: Video Engagement / Video Views',
  zh: '视频互动比例: 视频互动量 /视频观看量',
};